export const handleKeyPress = (event: any, value: any) => {
	if (event.key === 'Enter') {
		value()
	}
}
